import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRatingStar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.729,1.2l3.346,6.629,6.44.638a.805.805,0,0,1,.5,1.374l-5.3,5.253,1.965,7.138a.813.813,0,0,1-1.151.935L12,19.934,5.48,23.163a.813.813,0,0,1-1.151-.935L6.294,15.09.99,9.837a.805.805,0,0,1,.5-1.374l6.44-.638L11.271,1.2A.819.819,0,0,1,12.729,1.2Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})
});
export default SvgRatingStar;
